import { render, staticRenderFns } from "./LastIntervalReminder.vue?vue&type=template&id=dc1030d0&scoped=true&"
import script from "./LastIntervalReminder.vue?vue&type=script&lang=js&"
export * from "./LastIntervalReminder.vue?vue&type=script&lang=js&"
import style0 from "./LastIntervalReminder.vue?vue&type=style&index=0&id=dc1030d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1030d0",
  null
  
)

export default component.exports